<div class="">
    <div class="text-center pb-2">
        <span class="ps-1 pe-1">{{currentTime}} | {{currentDate}}</span>
    </div>
</div>